import { useQuery } from "@tanstack/react-query";

import { api } from "./api";

export interface Company {
  id: string;
  cuit: string;
  legalName: string;
  vatCondition: string;
  fiscalYearClosingMonth: number;
}

export function useCompanies() {
  return useQuery({ queryKey: ["companies"], queryFn: () => api.get<Company[]>("/api/companies") });
}

export function useCompany(companyId: string) {
  return useQuery({
    queryKey: ["companies", companyId],
    queryFn: () => api.get<Company>(`/api/companies/${companyId}`),
  });
}

export interface PeriodOverview {
  id: string;
  year: number;
  month: number;
  label: string;
  status: "abierto" | "en_revision" | "cerrado" | "presentado";
  compras: number;
  ventas: number;
  latestSnapshot: {
    version: number;
    createdAt: string;
    saldoAPagarCents: number;
    /** False when a change came after it (a voided voucher, a move): recalculate. */
    current: boolean;
  } | null;
}

export function usePeriods(companyId: string) {
  return useQuery({
    queryKey: ["periods", companyId],
    queryFn: () => api.get<PeriodOverview[]>(`/api/companies/${companyId}/periods`),
  });
}

export interface VoucherView {
  id: string;
  companyId: string;
  periodId: string;
  direction: "compra" | "venta";
  typeCode: number;
  typeName: string;
  letter: string;
  issueDate: string;
  pointOfSale: number;
  number: number;
  counterpart: { id: string; docType: number; docNumber: string; docDisplay: string; name: string };
  currency: string;
  exchangeRate: string;
  total: string;
  cae: string | null;
  source: "manual" | "import" | "settlement";
  importBatchId: string | null;
  settlementId: string | null;
  purchaseKind: "bienes" | "servicios" | "bienes_uso" | null;
  /** Voided (plan 024): it stays, struck through, and no longer counts. */
  voided: { at: string; by: string; reason: string } | null;
  lines: {
    lineNo: number;
    kind: string;
    rate: string | null;
    net: string;
    tax: string;
    jurisdiction: number | null;
  }[];
}
